// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__VLJKo","footerItems":"Footer_footerItems__Mqpp4","footerLogo":"Footer_footerLogo__eTpxs"};